import { AnyComponentTypography, FormCheckboxWithDayjsValue, Stack } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props {
  formIdentifier?: string;
}

export const FormCheckboxTermsOfService = ({ formIdentifier = "acceptedTermsOfService" }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <FormCheckboxWithDayjsValue
      name={formIdentifier}
      label={
        <Stack component="span" direction="row">
          <AnyComponentTypography component="span">{t("common:form.checkbox.terms.of.service")}&nbsp;</AnyComponentTypography>
          <AnyComponentTypography
            color="inherit"
            component="a"
            href="/terms-of-service"
            rel="noreferrer"
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            target="_blank"
            variant="body2"
          >
            Nutzungsbedingungen
          </AnyComponentTypography>
          <AnyComponentTypography component="span">.</AnyComponentTypography>
        </Stack>
      }
    />
  );
};
